"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardButtonRow = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
require("./row.css");
/** A component to display Card Buttons inside a row. */
const CardButtonRow = ({ className, dataTest = 'cardButtonRow', size = 'normal', children, ...other }) => {
    const classes = (0, classnames_1.default)('dsc-cardButtonRow', size !== 'normal' && `is-${size}`, className);
    return ((0, jsx_runtime_1.jsx)("div", { className: "dsc-cardButtonRow-container", children: (0, jsx_runtime_1.jsx)("div", { className: classes, "data-test": dataTest, ...other, children: children }) }));
};
exports.CardButtonRow = CardButtonRow;
//# sourceMappingURL=row.js.map